import styled from 'styled-components';

export const Select = styled.div`
  background: ${({ theme }) => theme.colors.white};
  border-radius: 4px;
  bottom: 100%;
  border: 1px solid ${({ theme }) => theme.colors.separatorOnWhite};
  box-shadow: ${({ theme }) => theme.boxShadows.bottomLight};
  display: grid;
  grid-gap: 0 10px;
  grid-template-columns: repeat(4, 1fr);
  padding: 3px 13px;
`;

export const Option = styled.button`
  background-color: transparent;
  border: 0;
  border-radius: 4px;
  cursor: pointer;
  font-size: 20px;
  padding: 2px 4px;
  transition: background-color 0.25s ease;

  &:hover {
    background-color: rgba(0, 128, 255, 0.08);
  }
`;

export const OpenPickerButton = styled.button`
  align-items: center;
  background: transparent;
  border: 0;
  color: ${({ theme }) => theme.colors.iconGray};
  cursor: pointer;
  justify-content: center;
  padding: 0;
  pointer-events: auto;
  transition: color 0.25s linear;

  &:hover {
    color: ${({ theme }) => theme.colors.primary};
  }
`;
